<script>
import Filtro from "./Panel";
import { mapGetters } from "vuex";
import Placeholder from "../Placeholder/Filtros/Destinos.vue";
export default {
  components: { Placeholder, Filtro },
  computed: {
    ...mapGetters(["isMaster", "inFiltroDestinos", "getFiltroDestinosLista"]),
  },
  data() {
    return { filtro: [] };
  },
  watch: {
    filtro(payload) {
      this.$store.commit("setFiltroDestinos", payload);
    },
  },
  methods: {
    clear() {
      if (this.filtro.length) {
        this.filtro = [];
      }
    },
  },
};
</script>

<template>
  <div>
    <filtro v-if="isMaster" heading="Ciudades de Destino" icono="map-marker-distance" :total="getFiltroDestinosLista.length">
      <div class="list-group">
        <label v-for="(item, key) in getFiltroDestinosLista" :key="key" class="list-group-item" :class="{active: inFiltroDestinos(item.id)}" >
          <input type="checkbox" :value="item.id" v-model="filtro" />
          <span v-html="item.nombre"></span>
        </label>
      </div>
    </filtro>
    <placeholder v-else></placeholder>
  </div>
</template>

<style lang="scss" scoped>
.list-group {
  margin: 0;
  border: 0;

  border-radius: 0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;

  min-height: 160px;
  max-height: 286px;
  overflow-y: scroll;

  > .list-group-item {
    display: block;
    font-weight: normal;
    border-radius: 0;
    border-left: 0;
    border-right: 0;
    cursor: pointer;
    position: relative;
    padding-left: 35px;

    &:first-child {
      border-top: 0;
    }

    &:last-child {
      border-bottom: 0;
    }

    &:hover {
      background: #f4f5f7;
      color: #434a54;
    }

    > input[type="checkbox"] {
      position: absolute;
      left: 15px;
      top: 15px;
      margin: 0;
      padding: 0;
    }
  }
}
</style>